import { render, staticRenderFns } from "./EmailAttachmentLink.vue?vue&type=template&id=1c5369d9&scoped=true&"
import script from "./EmailAttachmentLink.vue?vue&type=script&lang=js&"
export * from "./EmailAttachmentLink.vue?vue&type=script&lang=js&"
import style0 from "./EmailAttachmentLink.vue?vue&type=style&index=0&id=1c5369d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5369d9",
  null
  
)

export default component.exports